/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';
import {
  EditingState,
  SortingState,
  IntegratedSorting,
  DataTypeProvider,
  SearchState,
  IntegratedFiltering,
  PagingState,
  IntegratedPaging,
} from '@devexpress/dx-react-grid';
import {
  Grid,
  TableHeaderRow,
  TableEditColumn,
  Toolbar,
  SearchPanel,
  DragDropProvider,
  Table,
  TableColumnReordering,
  TableColumnResizing,
  PagingPanel,
} from '@devexpress/dx-react-grid-material-ui';
import { Command, PopupEditing } from '../../Shared';
import { getRowId, updateDocNumbers, userroles } from '../../common';
import {
  getRequests,
  createRequest,
  updateRequest,
  deleteRequest,
  getProducts,
} from '../../graphql';
import { useLazyQuery, useMutation } from '@apollo/client';
import {
  amountFormatter,
  contactTypeFormatter,
  docStatusFormatter,
  timevalueFormatter,
} from '../../Shared/colorFormat';
import { getColumns } from '../../common/columns';
import { SearchTable } from '../../components';
import PopupRequest from '../../pubups/PopupRequest';
import { useProducts, useTemplate } from '../../hooks';
import useDepartments from '../../hooks/useDepartments';
import useEmployees from '../../hooks/useEmployees';
import useResourses from '../../hooks/useResourses';
import useTasks from '../../hooks/useTasks';
import { Box, Typography } from '@material-ui/core';
import { TableComponent } from '../../Shared/ItemsTable';
import { moneyFormat } from '../common/formater';
import _ from 'lodash';
import PopupDocSteps from '../../pubups/PopupDocSteps';
import { contactthrough, procStatus } from '../../constants/datatypes';
import AutoFieldLocal from '../shared/AutoFieldLocal';
import usePrintTemplates from '../../hooks/usePrintTemplates';
import { getDefaultTemplate } from '../../common/helpers';
import { useReactToPrint } from 'react-to-print';
import PrintDownload from '../../Shared/PrintDownload';

const Requests = forwardRef((props: any, ref: any) => {
  const [selected, setSelected] = useState(null);
  const [open, setOpen] = useState(false);
  const [stepvalue, setStepvalue] = useState<any>(null);
  const [contactvalue, setContactvalue] = useState<any>(null);

  const { isRTL, words, start, end, theme, company, drawerWidth } = props;

  const onClose = () => {
    setOpen(false);
    setSelected(null);
  };

  const col = getColumns({ isRTL, words });

  const { tempoptions } = useTemplate();
  const [columns] = useState(
    [
      { name: 'time', title: words?.time },
      { name: 'docNo', title: words?.no },
      { name: 'customerName', title: words?.name },
      { name: 'customerPhone', title: isRTL ? 'الهاتف' : 'Phone' },
      // col.title,
      col.desc,
      { name: 'paymentType', title: isRTL ? 'طريقة التواصل' : 'Contact Type' },
      { name: 'stepId', title: isRTL ? 'الحالة' : 'Status' },
      { name: 'stepTime', title: isRTL ? 'اخر تحديث' : 'Last Update' },
      { name: 'stepDesc', title: isRTL ? 'بيان التحديث' : 'Update Note' },
      { name: 'stepUserName', title: isRTL ? 'المستخدم' : 'User' },
    ].filter((x) => x)
  );

  const [tableColumnExtensions]: any = useState([
    { columnName: 'time', width: 120 },
    { columnName: 'docNo', width: 120 },
    { columnName: 'customerName', width: 180 },
    { columnName: 'customerPhone', width: 150 },
    { columnName: 'paymentType', width: 150 },
    // { columnName: col.title.name, width: 180 },
    { columnName: col.desc.name, width: 200 },
    { columnName: 'stepId', width: 150, align: 'center' },
    { columnName: 'stepTime', width: 150 },
    { columnName: 'stepDesc', width: 200 },
    { columnName: 'stepUserName', width: 150 },
  ]);

  const [rows, setRows] = useState([]);
  const [sum, setSum] = useState(0);

  const { tasks } = useTasks();

  const { products } = useProducts();
  const { departments } = useDepartments();
  const { employees } = useEmployees();
  const { resourses } = useResourses();
  const { printtemplates } = usePrintTemplates();

  const [loadRequests, opData]: any = useLazyQuery(getRequests, {
    fetchPolicy: 'cache-and-network',
  });

  const refresQuery = {
    refetchQueries: [
      {
        query: getRequests,
        variables: {
          start: start ? start.setHours(0, 0, 0, 0) : undefined,
          end: end ? end.setHours(23, 59, 59, 999) : undefined,
          stepId: stepvalue?.id,
        },
      },
      { query: getProducts },
    ],
  };

  useEffect(() => {
    const variables = {
      start: start ? start.setHours(0, 0, 0, 0) : undefined,
      end: end ? end.setHours(23, 59, 59, 999) : undefined,
      stepId: stepvalue?.id,
    };
    if (start) {
      loadRequests({
        variables,
      });
    }
  }, [start, end, stepvalue]);

  const [addRequest] = useMutation(createRequest, refresQuery);
  const [editRequest] = useMutation(updateRequest, refresQuery);
  const [removeRequest] = useMutation(deleteRequest, refresQuery);

  useImperativeHandle(ref, () => ({
    refresh() {
      if (opData?.refetch) {
        opData.refetch();
      }
    },
  }));

  const commitChanges: any = async ({ deleted }) => {
    if (deleted) {
      const _id = deleted[0];
      removeRequest({ variables: { _id } });
      setRows(rows.filter((row: any) => row._id !== _id));
    }
  };

  useEffect(() => {
    if (opData?.data?.getRequests?.data) {
      const { data } = opData.data.getRequests;
      const fdata = contactvalue
        ? data.filter(
            (x: any) =>
              x.paymentType === contactvalue.name ||
              x.paymentType === contactvalue.nameAr
          )
        : data;
      const rdata = updateDocNumbers(fdata);
      const samount = _.sumBy(rdata, 'amount');
      setSum(samount);
      setRows(rdata);
    }
  }, [opData, contactvalue]);

  const componentRef: any = useRef();

  const template = getDefaultTemplate(printtemplates, 'requests');

  const handleReactPrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: `Requests Report`,
    removeAfterPrint: true,
  });

  const printData = {
    start,
    end,
    items: rows,
    isRTL,
    date: new Date(),
    company,
  };

  return (
    <>
      <Box
        style={{
          position: 'absolute',
          left: isRTL ? 750 : undefined,
          right: isRTL ? undefined : 750,
          top: 45,
          zIndex: 112,
        }}
      >
        <PrintDownload
          company={company}
          printData={printData}
          componentRef={componentRef}
          handleReactPrint={handleReactPrint}
          isRTL={isRTL}
          template={template}
          no={'sales report'}
          element="salesreport"
        ></PrintDownload>
      </Box>
      <Box
        style={{
          position: 'absolute',
          zIndex: 111,
          left: isRTL ? undefined : drawerWidth + 50,
          right: isRTL ? drawerWidth + 50 : undefined,
          bottom: 50,
          display: 'flex',
          flex: 1,
          alignItems: 'center',
          justifyContent: 'flex-end',
        }}
      >
        <Typography
          style={{
            color: '#333',
            marginLeft: 20,
            marginRight: 20,
          }}
        >
          {isRTL ? ' المجموع ' : ' Total '}: {moneyFormat(sum)}
        </Typography>
      </Box>
      <Box
        display="flex"
        style={{
          position: 'absolute',
          top: 55,
          width: 400,
          left: isRTL ? 330 : undefined,
          right: isRTL ? undefined : 350,
          zIndex: 111,
        }}
      >
        <AutoFieldLocal
          Required
          name="procitem"
          title={isRTL ? 'الحالة' : 'Status'}
          words={words}
          options={procStatus}
          value={stepvalue}
          setSelectValue={setStepvalue}
          isRTL={isRTL}
          fullWidth
          mb={0}
        ></AutoFieldLocal>
        <AutoFieldLocal
          Required
          name="contact"
          title={isRTL ? 'التواصل' : 'Contact'}
          words={words}
          options={contactthrough}
          value={contactvalue}
          setSelectValue={setContactvalue}
          isRTL={isRTL}
          fullWidth
          mb={0}
        ></AutoFieldLocal>
      </Box>
      <Grid rows={rows} columns={columns} getRowId={getRowId}>
        <SortingState />
        <EditingState onCommitChanges={commitChanges} />
        <SearchState />
        <PagingState defaultCurrentPage={0} defaultPageSize={10} />
        <IntegratedSorting />
        <IntegratedFiltering />
        <IntegratedPaging />
        <DragDropProvider />
        <Table
          messages={{
            noData: isRTL ? 'لا يوجد بيانات' : 'no data',
          }}
          tableComponent={TableComponent}
          rowComponent={(props: any) => (
            <Table.Row {...props} style={{ height: 60 }}></Table.Row>
          )}
          columnExtensions={tableColumnExtensions}
        />

        <TableColumnReordering
          defaultOrder={[
            'time',
            'docNo',
            col.customer.name,
            col.title.name,
            col.desc.name,
            'paymentType',
            'stepId',
            'stepTime',
            'stepDesc',
            'stepUserName',
          ]}
        />
        <TableColumnResizing defaultColumnWidths={tableColumnExtensions} />

        <TableHeaderRow
          showSortingControls
          titleComponent={({ children }) => {
            return (
              <Typography style={{ fontSize: 14, fontWeight: 'bold' }}>
                {children}
              </Typography>
            );
          }}
        />
        <DataTypeProvider
          for={['time', 'stepTime']}
          formatterComponent={timevalueFormatter}
        ></DataTypeProvider>
        <DataTypeProvider
          for={['amount']}
          formatterComponent={amountFormatter}
        ></DataTypeProvider>
        <DataTypeProvider
          for={['paymentType']}
          formatterComponent={contactTypeFormatter}
        ></DataTypeProvider>
        <DataTypeProvider
          for={['stepId']}
          formatterComponent={(props: any) =>
            docStatusFormatter({
              ...props,
              isRTL,
              setSelected,
              setOpen,
            })
          }
        ></DataTypeProvider>
        <TableEditColumn
          showEditCommand={userroles?.purchase?.add}
          showDeleteCommand={userroles?.purchase?.delete}
          showAddCommand={userroles?.purchase?.add}
          commandComponent={Command}
        ></TableEditColumn>
        <Toolbar
          rootComponent={(props: any) => (
            <Toolbar.Root
              style={{
                position: 'absolute',
                left: isRTL ? 40 : undefined,
                right: isRTL ? undefined : 40,
                top: 62,
                zIndex: 115,
              }}
              {...props}
            ></Toolbar.Root>
          )}
        />
        <PagingPanel
          pageSizes={
            tempoptions?.pageall ? [5, 10, 20, 50, 0] : [5, 10, 20, 50]
          }
        />

        <SearchPanel
          inputComponent={(props: any) => {
            return <SearchTable isRTL={isRTL} {...props}></SearchTable>;
          }}
        />

        <PopupEditing addAction={addRequest} editAction={editRequest}>
          <PopupRequest
            resourses={resourses}
            employees={employees}
            departments={departments}
            company={company}
            servicesproducts={products}
            tasks={tasks}
            theme={theme}
          ></PopupRequest>
        </PopupEditing>
      </Grid>
      <PopupDocSteps
        open={open}
        onClose={onClose}
        row={selected}
        theme={theme}
      ></PopupDocSteps>
    </>
  );
});

export default Requests;
